window.changeAdjustedTemperature = function() {
    thermometer_id = $('#thermometer_id').val();
    temperature = $('#temperature').val();
    $.ajax({
        url: `/factory/equipment/thermometers/${thermometer_id}/adjust_temperature`,
        type: 'POST',
        data:{
            measures: {temperature: temperature}
        }
    }).done(function(e) {

    });  

}